/**
 * CMS 界面主题注册表：新增主题时在此登记 id / 文案，并补充对应 themes/*.css token 文件。
 * 启动策略见 cmsThemeService：未固定用户 → 每会话随机；主动选定 → localStorage 固定。
 */
export const CMS_THEME_DEFAULT_ID = 'warm-atelier'

export const CMS_THEMES = [
  {
    id: 'warm-light',
    label: '暖灰 Light',
    description: '暖灰 canvas + 轻立体阴影（Elevation）',
    available: true,
  },
  {
    id: 'studio',
    label: 'Studio',
    description: '中性 zinc · 单工作区 · 单 accent 高级感',
    available: true,
  },
  {
    id: 'paper-editorial',
    label: 'Paper Editorial',
    description: '纸感编辑 · 大留白 · 衬线标题',
    available: true,
  },
  {
    id: 'warm-atelier',
    label: 'Warm Atelier',
    description: '暖奢工作室 · 石色画布 · 赤陶 accent',
    available: true,
  },
  {
    id: 'glass-atelier',
    label: 'Glass Atelier',
    description: '极致冷色玻璃 · 冰蓝 Aurora · cyan accent',
    available: true,
  },
  {
    id: 'classic',
    label: '经典',
    description: '净白 #FAFAFA · 纯白卡片 · Teal 主色 · 多色 pastel accent',
    available: true,
  },
]

/** 按 id 查找主题元数据；非法 id 回退默认主题 */
export function resolveCmsThemeMeta(themeId) {
  const found = CMS_THEMES.find((item) => item.id === themeId)
  if (found && found.available) {
    return found
  }
  return CMS_THEMES.find((item) => item.id === CMS_THEME_DEFAULT_ID)
}

export function isCmsThemeAvailable(themeId) {
  const meta = CMS_THEMES.find((item) => item.id === themeId)
  return Boolean(meta && meta.available)
}
